const uuidSet = new Set();
const generateId = () => 'genxxxx-xxxx-xxx-xxxx'.replace(/[x]/g, () => {
  const r = Math.floor(Math.random() * 16);
  return r.toString(16);
});

const generateUuid = () => {
  let id = generateId();
  while (uuidSet.has(id)) {
    id = generateId();
  }
  uuidSet.add(id);

  return id;
};

export default generateUuid;
